import React from 'react';

import {Icon, IconButton, Text} from '@albert-io/atomic';

import type {CreatedHomeschool} from './schoolAssociation.types';

interface CreatedHomeschoolCardProps {
  school: CreatedHomeschool;
  onDelete: () => void;
  onEdit: () => void;
}

export default function CreatedHomeschoolCard({
  school,
  onDelete,
  onEdit
}: CreatedHomeschoolCardProps) {
  return (
    <div className='flex items-center gap-x2 rounded-[12px] border border-primary p-x2'>
      <div className='flex h-x6-quarter w-x6-quarter items-center justify-center rounded-x1 background-brand-subtle'>
        <Icon icon={['fas', 'school']} color='brand' size='standalone' />
      </div>
      <div className='flex flex-1 flex-col'>
        <Text className='text-l font-bold'>{school.name}</Text>
        <Text color='secondary' size='s'>
          {school.city}, {school.state === '' ? school.country : school.state}
        </Text>
      </div>
      <div className='flex gap-x1'>
        <IconButton
          color='secondary'
          variant='text'
          size='s'
          icon={['far', 'trash-can']}
          label='Delete'
          onClick={onDelete}
        />
        <IconButton
          color='secondary'
          variant='text'
          size='s'
          icon={['far', 'pencil']}
          label='Edit'
          onClick={onEdit}
        />
      </div>
    </div>
  );
}
